import { ModalOverlay } from '@chakra-ui/react';

export default function ChakraModalOverlay({ ...props }) {
    return <ModalOverlay {...props} />;
}
